<template>
  <div class="Categoria__Wrapper">
    <v-row>
      <v-col cols="12" sm="3">
        <metadados-extensao-form
          ref="CategoriaForm"
          :id="idCategoria"
          :idNivelExtensao="idNivelExtensao"
          :somenteLeitura="somenteLeitura"
          :mostrarAtivacao="false"
          :indRecursiva="item.indRecursiva"
          :tipoCadastro="$tc(`label.${item.label.toLowerCase()}`, 1)"
          :input-layout="inputLayout">
          <template slot="contentPreForm">
            <v-col cols="12">
              <v-select
                class="Form-text__invalid"
                id="tipo"
                name="tipo"
                item-text="nome"
                item-value="id"
                return-object
                clearable
                :items="tipos"
                :disabled="!!idCategoria || somenteLeitura"
                @input="carregarExtensoesPais"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                :label="`${$tc('label.tipo', 1)} *`"
                v-model="objeto.tipo"
                :rules="[rules.required]">
              </v-select>
            </v-col>
          </template>
          <template slot="contentPosForm">
            <v-col cols="12">
              <v-autocomplete
                class="Form-text__invalid"
                id="pai"
                name="pai"
                v-model="objeto.pai"
                item-text="nomExtensao"
                item-value="id"
                :label="`${$tc('label.pai', 1)} ${montarDescricaoTipoLabel()} ${maiorIndice == (objeto.tipo && objeto.tipo.indice ? objeto.tipo.indice : objeto.indice) ? '' : '*'}`"
                :items="pais"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                :filter="filtroPai"
                :search-input.sync="buscaListaPais"
                :rules="[rules.requiredPai]"
                :disabled="!!idCategoria || somenteLeitura"
                clearable
                return-object>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <div class="d-flex align-center justify-space-between">
                <label for="nom_extensao_oracle" class="v-label theme--light">Descrição Oracle{{ isTenantMagalu ? ' *' : '' }}</label>
                <v-tooltip bottom v-if="canAlterarDescricaoOracle">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="habilitarEdicaoCampo('nomExtensaoOracle')" :disabled="somenteLeitura">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar descrição Oracle</span>
                </v-tooltip>
              </div>
              <v-text-field
                id="nom_extensao_oracle"
                name="nom_extensao_oracle"
                v-model="objeto.nomExtensaoOracle"
                :rules="regrasDescricaoOracle"
                :disabled="somenteLeitura || !canAlterarDescricaoOracle || !edicaoCampoOracle.nomExtensaoOracle"
                maxlength="100"
                counter="100"
                class="Form-text__invalid"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <div class="d-flex align-center justify-space-between">
                <label for="ind_provisionada" class="v-label theme--light">Provisionada *</label>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="habilitarEdicaoCampo('indProvisionada')" :disabled="somenteLeitura">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar provisionamento</span>
                </v-tooltip>
              </div>
              <select-button-toggle
                id="ind_provisionada"
                name="ind_provisionada"
                v-model="objeto.desAtributos.indProvisionada"
                :options="opcoesProvisionada"
                :rules="regrasProvisionada"
                :disabled="somenteLeitura || !edicaoCampoOracle.indProvisionada"
                class="mt-3"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <div class="d-flex align-center justify-space-between">
                <label for="status_categoria_oracle" class="v-label theme--light">Status *</label>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="habilitarEdicaoCampo('status')" :disabled="somenteLeitura">
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar status</span>
                </v-tooltip>
              </div>
              <select-button-toggle
                id="status_categoria_oracle"
                name="status_categoria_oracle"
                v-model="objeto.desAtributos.status"
                :options="opcoesStatus"
                :rules="regrasStatus"
                :disabled="somenteLeitura || !edicaoCampoOracle.status"
                class="mt-3"
              />
            </v-col>
          </template>
          <template slot="button">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="cancelar" :disabled="somenteLeitura">{{ $t('label.cancelar') }}</v-btn>
              <v-btn @click.native="abrirDialogSalvar" color="primary" :disabled="somenteLeitura">{{ $t('label.salvar') }}</v-btn>
            </v-card-actions>
          </template>
        </metadados-extensao-form>
      </v-col>
      <v-col cols="12" sm="9">
        <categoria-tabela
          ref="CategoriaTabela"
          id="categoria-tabela"
          :titlePage="item.indRecursiva ? $tc('label.categoria', 1) : item.entidadeEstrangeira" :idNivelExtensao="idNivelExtensao"
          @edit="editarCampo"
          :somenteLeitura="somenteLeitura"
          class="Categoria__ContentTable"/>
      </v-col>
    </v-row>
    <confirm
      ref="confirmDialog"
      :message="$t('message.deseja_salvar', { text: $tc(`label.${item.label}`, 1) })"
      :persistent="true"
      @agree="salvar">
    </confirm>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import MetadadosExtensaoForm from '@/shared-components/metadados-extensao/MetadadosExtensaoForm';
import Confirm from '@/shared-components/dialog/Confirm';
import CategoriaTabela from './CategoriaTabela';

export default {
  name: 'TabelaGenericaRecursiva',
  data() {
    return {
      idCategoria: null,
      inputLayout: {
        ml1: false,
        mt1: false,
        mt2: true,
      },
      maiorIndice: null,
      pais: [],
      objeto: {
        indAtivo: true,
        nomExtensaoOracle: null,
        desAtributos: {},
      },
      objetoLabelSelecionado: {},
      tipos: [],
      buscaListaPais: null,
      extensaoResources: this.$api.extensao(this.$resource),
      nivelProdutoResources: this.$api.nivelProduto(this.$resource),
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredPai: value => this.tipoValido() ? true : // eslint-disable-line
          (!this.tipoValido() && !value ? this.$t('message.campo_obrigatorio') : true), // eslint-disable-line
      },
      edicaoCampoOracle: {
        nomExtensaoOracle: false,
        indProvisionada: false,
        status: false,
      },
      opcoesProvisionada: [
        { label: this.$t('label.sim'), value: true },
        { label: this.$t('label.nao'), value: false },
      ],
      opcoesStatus: [
        { label: this.$t('label.ativo'), value: 'ATIVO' },
        { label: this.$t('label.inativo'), value: 'INATIVO' },
      ],
    };
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    idNivelExtensao: Number,
  },
  components: {
    CategoriaTabela,
    Confirm,
    MetadadosExtensaoForm,
  },
  watch: {
    buscaListaPais(val) {
      if (this.timeoutProduto) {
        window.clearTimeout(this.timeoutProduto);
      }
      this.timeoutProduto = window.setTimeout(() => {
        this.buscarPaiAutocomplete(val);
      }, 500);
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isTenantMagalu() {
      return this.getTenantId === 'magalu';
    },
    canAlterarDescricaoOracle() {
      return this.possuiRole('ROLE_CATEGORIA_AUDITORIA_ALTERAR');
    },
    regrasDescricaoOracle() {
      return this.isTenantMagalu ? [this.rules.required] : [];
    },
    regrasProvisionada() {
      return [this.rules.required];
    },
    regrasStatus() {
      return [this.rules.required];
    },
  },
  methods: {
    possuiRole(role) {
      return !!(this.getAllRoles && this.getAllRoles.includes(role));
    },
    habilitarEdicaoCampo(campo) {
      this.edicaoCampoOracle[campo] = true;
    },
    bloquearEdicaoCamposOracle() {
      this.edicaoCampoOracle.nomExtensaoOracle = false;
      this.edicaoCampoOracle.indProvisionada = false;
      this.edicaoCampoOracle.status = false;
    },
    obterAtributoCategoria(item, chave, aliases = []) {
      if (!item) {
        return null;
      }

      const chaves = [chave, ...aliases];

      if (item.desAtributos) {
        const atributoDesAtributos = chaves.find((chaveAtual) => item.desAtributos[chaveAtual] !== undefined
          && item.desAtributos[chaveAtual] !== null);

        if (atributoDesAtributos) {
          return item.desAtributos[atributoDesAtributos];
        }
      }

      const atributoItem = chaves.find((chaveAtual) => item[chaveAtual] !== undefined
        && item[chaveAtual] !== null);

      if (atributoItem) {
        return item[atributoItem];
      }

      return null;
    },
    obterNomExtensaoOracle(item) {
      return this.obterAtributoCategoria(item, 'nomExtensaoOracle', ['nomextensaooracle', 'nom_extensao_oracle']);
    },
    abrirDialogSalvar() {
      if (!this.$refs.CategoriaForm.validarFormulario()) return;
      this.$refs.confirmDialog.open();
    },
    atualizarGrid() {
      this.$refs.CategoriaTabela.filtrar();
    },
    buscarMetadadosLabels() {
      return this.nivelProdutoResources.labels().then((resultado) => {
        this.tipos = resultado.data;
        this.maiorIndice = Math.max(...this.tipos.map((tipo) => tipo.indice));
      });
    },
    cancelar() {
      this.limparFormulario();
    },
    carregarExtensoesPais(objeto) {
      if (!objeto) return;
      this.$refs.CategoriaForm.limparValidacoes();
      this.objetoLabelSelecionado = objeto;
      const filtroDesAtributo = 'indiceLabel';
      const filtroDesAtributoValor = objeto.indice + 1;
      const params = {
        ...null,
        idNivelExtensao: this.idNivelExtensao,
        limit: 30,
        tamanhoPagina: 30,
        filtroDesAtributo,
        filtroDesAtributoValor,
      };

      if (this.idCategoria != null) {
        params.limit = 200;
        params.tamanhoPagina = 200;
      }

      this.extensaoResources.listarAtivos(params).then((resultado) => {
        this.pais = resultado.data.resposta;
      });
    },
    filtroPai(item, queryText, itemText) {
      const codPai = item.idExterno;
      const searchText = queryText.toLowerCase();

      return codPai.toLowerCase().indexOf(searchText) > -1
        || itemText.toLowerCase().indexOf(searchText) > -1;
    },
    buscarPaiAutocomplete(busca = null) {
      const filtroDesAtributo = 'indiceLabel';
      const filtroDesAtributoValor = this.objetoLabelSelecionado.indice + 1;
      const params = {
        ...null,
        idNivelExtensao: this.idNivelExtensao,
        autocomplete: busca,
        limit: 30,
        tamanhoPagina: 30,
        page: 0,
        filtroDesAtributo,
        filtroDesAtributoValor,
      };

      if (this.idCategoria != null) {
        params.limit = 200;
        params.tamanhoPagina = 200;
      }

      this.extensaoResources.listarAtivos(params).then((resultado) => {
        this.pais = resultado.data.resposta;
      }, (err) => {
        this.$error(this, err);
      });
    },
    editarCampo(item) {
      this.idCategoria = item.id;
      item = this.setAtributos(item);
      this.$refs.CategoriaForm.iniciarEdicao(item);
    },
    limparFormulario() {
      this.$refs.CategoriaForm.limparFormulario();
      this.objetoLabelSelecionado = {};
      this.pais = [];
      this.idCategoria = null;
      this.objeto.nomExtensaoOracle = null;
      this.objeto.desAtributos = {};
      this.bloquearEdicaoCamposOracle();
    },
    montarDesAtributos() {
      const desAtributos = {
        ...(this.objeto.desAtributos || {}),
      };

      desAtributos.nomExtensaoOracle = this.objeto.nomExtensaoOracle;

      if (this.objetoHasProperties(this.objetoLabelSelecionado)) {
        return desAtributos;
      }

      desAtributos.nomeLabel = this.objetoLabelSelecionado.label;
      desAtributos.indiceLabel = this.objetoLabelSelecionado.indice;
      return desAtributos;
    },
    montarDescricaoTipoLabel() {
      if (this.pais && this.pais.length > 0) {
        return this.pais[0].desAtributos && this.pais[0].desAtributos.nomeLabel
          ? `(${this.pais[0].desAtributos.nomeLabel})` : '';
      }
      return '';
    },
    objetoHasProperties(objeto) {
      if (typeof (objeto) === 'number') {
        return false;
      }

      return Object.keys(objeto).length === 0
        && objeto.constructor === Object;
    },
    prepararObjeto() {
      const objetoComponente = this.$refs.CategoriaForm.prepararObjeto();
      this.objeto.pai = this.objeto.pai
        ? this.objeto.pai.id || this.objeto.pai : null;
      this.objeto.id = objetoComponente.id;
      this.objeto.idExterno = objetoComponente.idExterno;
      this.objeto.nomExtensao = objetoComponente.nomExtensao;
      this.objeto.nomExtensaoOracle = objetoComponente.nomExtensaoOracle
        || this.objeto.desAtributos.nomExtensaoOracle;

      const { status } = this.objeto.desAtributos;
      if (status === 'INATIVO') {
        this.objeto.indAtivo = false;
      } else if (status === 'ATIVO') {
        this.objeto.indAtivo = true;
      } else {
        this.objeto.indAtivo = objetoComponente.indAtivo;
      }
      this.objeto.idNivelExtensao = this.idNivelExtensao;
      this.objeto.desAtributos = this.montarDesAtributos();
      return this.objeto;
    },
    salvar() {
      if (this.idCategoria) {
        this.extensaoResources.atualizarAutoRelacionamento({ id: this.id }, this.prepararObjeto())
          .then(() => {
            this.$toast(this.$t('message.atualizado_confira_tabela'));
            this.limparFormulario();
            this.atualizarGrid();
          }, (err) => {
            this.$error(this, err);
          });
      } else {
        this.extensaoResources.gravarAutoRelacionamento(this.prepararObjeto())
          .then(() => {
            this.$toast(this.$t('message.adicionado_confira_tabela'));
            this.limparFormulario();
            this.atualizarGrid();
          }, (err) => {
            this.$error(this, err);
          });
      }
    },
    setAtributos(item) {
      item.tipo = item.idMetadadosExtensaoRecursiva;
      item.pai = item.idPai;
      item.nomExtensao = item.nomExtensao || item.nomextensao;
      item.idExterno = item.idExterno || item.idexterno;
      const statusCategoria = this.obterAtributoCategoria(item, 'status')
        || (item.indAtivo ? 'ATIVO' : 'INATIVO');
      const nomExtensaoOracle = this.obterNomExtensaoOracle(item);
      this.objeto.desAtributos = {
        ...(item.desAtributos || {}),
        nomExtensaoOracle,
        indProvisionada: this.obterAtributoCategoria(item, 'indProvisionada'),
        status: statusCategoria,
      };
      this.objeto.nomExtensaoOracle = nomExtensaoOracle;
      this.bloquearEdicaoCamposOracle();
      this.carregarExtensoesPais(this.tipos.filter((tipo) => tipo.id === item.tipo)[0]);
      this.objeto.tipo = item.idMetadadosExtensaoRecursiva;
      this.objeto.indice = parseInt(item.indice, 10);
      this.objeto.pai = item.idPai;
      return item;
    },
    tipoValido() {
      if (this.objeto) {
        return this.maiorIndice === (this.objeto.tipo && this.objeto.tipo.indice
          ? this.objeto.tipo.indice : this.objeto.indice);
      }
      return true;
    },
  },
  mounted() {
    this.buscarMetadadosLabels();
    if (this.isTenantEpoca) {
      this.somenteLeitura = true;
    }
  },
};
</script>
<style>
  .Categoria__ContentTable {
    width: 100% !important;
  }
</style>
